import { PASSWORD_STRENGTH_REGEX } from 'global/appConstants';
import yup from 'utils/yup';

export const initialPersonalDetailsData = {
  firstName: '',
  lastName: '',
  email: '',
  job_title: '' as any,
  password: '',
  showPassword: false,
  message: '',
};

export const personalDetailsValidationSchema = yup.object().shape({
  firstName: yup.string().required().min(2),
  lastName: yup.string().required().min(2),
  email: yup.string().email().required(),
  job_title: yup.string().required(),
  password: yup
    .string()
    .required()
    .matches(PASSWORD_STRENGTH_REGEX, () => ({
      msg: 'common:passwordStrengthMessage',
    })),
});
